import { styled } from "@mui/material/styles"
import MuiTextField from "@mui/material/TextField"

type StyledTextFieldProps = {
    display?: "none" | "block" | "flex" | "inline-flex" | "inline-block" | "hidden"
}

export const TextField = styled(MuiTextField)<StyledTextFieldProps>(({ theme }) => ({
    margin: 0,

    "&.MuiFormControl-root": {
        backgroundColor: "transparent",
    },

    "& > .MuiOutlinedInput-root": {
        backgroundColor: theme.palette["primary"].contrastText,
        borderRadius: theme.spacing(3),
    },
}))